import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-print-report-logs',
  templateUrl: './print-report-logs.component.html',
  styleUrls: ['./print-report-logs.component.scss']
})
export class PrintReportLogsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
